export var EXPERT_MINIMAL_WIDTH = 240;
export var MAX_PER_PAGE = 4;